<template>
  <div class="pageFooterWrapper">
    <div class="pageFooter">
      <slot name="apply"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pageFooterWrapper {
  height: 116px;
  width: 750px;
  margin: 0 auto;
}
.pageFooter {
  background: #fff;
  height: 116px;
  width: 750px;
  padding: 0 32px;
  box-sizing: border-box;
  position: fixed;
  left: 50%;
  bottom: 0;
  margin-left: -375px;
  display: flex;
  align-items: center;
  z-index: 99;
}
</style>
